import React from 'react';
import  AccountProfileDetails  from './Form_micuenta';
import {db} from '../../../firebase';
import { useSelector} from 'react-redux';
import { MenuTopDashboard } from '../../../components/header/MenuTopDashboard/MenuTopDashboard'
import {OpcionesLaterales} from './OpcionesLaterales'
import {
  Avatar,
  Box,
  Card,
  CardActions,
  CardContent,
  Divider,
  Typography
} from '@mui/material';
import { Button, Container } from 'semantic-ui-react';
import { Grid } from 'semantic-ui-react';
import useObtenerDatosdeCliente from '../../../hooks/obtenerDatosdeCliente';
import useObtenerDetallesdecuenta from '../../../hooks/obtenerDetallesdecuenta';
import useObtenerBalance from '../../../hooks/obtenerBalance';
import { CircularProgress } from '@mui/material'
const user = {
  avatar: '/static/images/avatars/avatar_12.png',
  city: 'Region Metrpolitana',
  country: 'CHILE',
  jobTitle: 'Senior Developer',
  name: 'Usuario Cliente',
  timezone: 'GTM-3'
};

const Micuenta = (props ) => {
  //console.log(props)
  
  const userUid = useSelector(store => store.usuario.user.uid)

  const {userdataClient, data,  loadingDatosdeCliente, errorDatosdeCliente } = useObtenerDatosdeCliente(userUid)//(userUid)
  const[userData,setUserData] = React.useState('')
  const {accountDetails, accountDetailsHistory, loadingDetallesdecuenta, errorDetallesdecuenta,  availableservices} = useObtenerDetallesdecuenta(userData.userCompanyID)//(userUid)
  const {userBalance, loadingBalance, errorBalance } = useObtenerBalance(userData.userCompanyID)//(userUid)



  const[userDisplayName,setDisplayName] = React.useState()
  const[city,setCity ] = React.useState('')
  const[country,setCountry ] = React.useState('')
  const[avatar,setAvatar]   = React.useState('')
  
  


  React.useEffect(() => {
        obtenerDatosdeCliente(userUid)
  }, [userUid])
  React.useEffect(() => {
    setAvatar(userData.avatar)
    setDisplayName( userData.userName)
    //console.log(availableservices)
}, [userData])
  //Buscar Valores por defecto

  const obtenerDatosdeCliente = async (userUid) => {
    try {
      const accountants = await db.collection(`${process.env.REACT_APP_COL_USERS}`)
      .doc(userUid)
      .get();
      var data = accountants.data();
          // SETERS
            setUserData(data)
        } catch (error) {}
      } 
      
const createnewcompany = () =>{
  props.history.push(`/dashboard/companies`)
}
      return (  
  
    <Grid celled='internally'  id='mi-cuentaContent'>
      <div><h2>Mi cuenta</h2></div>
    <Grid.Row> 
    <Grid.Column  computer={3} mobile={16} tablet={16}  id='mi-cuentaContainer' >
    <Card >
    <CardContent>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Avatar
          src={avatar}
          sx={{
            height: 64,
            mb: 2,
            width: 64
          }}
        />
        <Typography
          color="textPrimary"
          gutterBottom
          variant="h5"
        >
          {userDisplayName}
        </Typography>
        <Typography
          color="textSecondary"
          variant="body2"
        >
          {`${user.city} ${user.country}`}
        </Typography>
        <Typography
          color="textSecondary"
          variant="body2"
        >
          {user.timezone}
        </Typography>
      </Box>
    </CardContent>
    <Divider />
    <CardActions>
      {/* <Button
        color="primary"
        fullWidth
        variant="text"
        
      >
        Actualizar foto
      </Button> */}
    </CardActions>
    </Card> 
    <br></br>
    <Card >
    <CardContent>
              <h3>Empresa</h3>
              {
               data?(<>
                <Box
                  sx={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  <Avatar
                    src={data.companyImgLogo}
                    sx={{
                      height: 64,
                      mb: 2,
                      width: 64
                    }}
                  />
                  <Typography
                    color="textPrimary"
                    gutterBottom
                    
                  >
                    {data.companyName}
                  </Typography>
                  <Typography
                    color="textSecondary"
                    variant="body2"
                  >
                    {`${data.companyRegion} ${data.companyCity}`}
                  </Typography>
                  <Typography
                    color="textSecondary"
                    variant="body2"
                  >
                    {data.companyRut}
                  </Typography>
                </Box>
                </>):(<>
                {
                  errorDatosdeCliente?(<>Registra tu empresa para realizar envíos<br></br> <Button onClick={createnewcompany}>Ir..</Button></>):(<>
                  {
                    loadingDatosdeCliente?(<><CircularProgress /></>):(<>
                    2
                    </>)
                  }
                  
                  </>)
                }
                
                
                </>)
              }
              </CardContent>
              <Divider />
             
              <CardActions>
                {/* <Button
                  color="primary"
                  fullWidth
                  variant="text"
                  
                >
                  Actualizar foto
                </Button> */}
              </CardActions>
             
              </Card> 

              </Grid.Column>
              <Grid.Column  computer={9} mobile={16} tablet={16} className="dash-container-colmun" >
              <Card>
              <CardContent>
                <Box
                  sx={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                    <MenuTopDashboard props={props}/>
                </Box>
              </CardContent>
              <Divider />

    </Card> 
    <Container>
    <Card className='typeMiniforms'>
      
    <CardContent>
      <h3>Mis planes y bolsas de envíos adquiridos</h3>

      <Card  sx={{ alignItems: 'lef',
                          display: 'inline-block',
                          flexDirection: 'column',
                          margin: '5px',
                          border: '1px solid #cbcbcb',
                          padding: '10px',
                          radius: '8px',
                        }}>
                  <CardContent>
                    <h3>Detallates de cuenta:</h3>
                      <Box>
                        {
                          accountDetails?(<>
                        {`Último Pago:         ${accountDetails.lastRecharge}`}<br></br>
                        {`Envíos disponibles:  ${accountDetails.shipmentsAvailable}`}<br></br>
                        {`Método de pago:  ${accountDetails.payMethod}`}<br></br>
                        {`Opción de pago:  ${accountDetails.payOptions}`}<br></br>
                         </>):(<>
                         {
                        loadingDetallesdecuenta?(<><CircularProgress /></>):(<>
                          {
                            errorDetallesdecuenta?(<>Sin registros</>):(<>
                            Error252
                            </>)
                          }
                          </>)
                         }
                          </>)         
                        }
                      </Box>
                    </CardContent>
                    <Divider />
        </Card> 
        <Card  sx={{ alignItems: 'lef',
                          display: 'inline-block',
                          flexDirection: 'column',
                          margin: '5px',
                          border: '1px solid #cbcbcb',
                          padding: '10px',
                          radius: '8px',
                        }}>
                  <CardContent>
                    <h3>Balance de Cuenta:</h3>
                      <Box>
                        {
                          userBalance?(<>
                        {`Estatus una cuenta :         ${userBalance.isActiveWallet}`}<br></br>
                        {`Pagos pendientes:  $ ${userBalance.pendingPayment}`}<br></br>
                        {`Envios disponibles:  ${userBalance.balance}`}<br></br>
                        {`Cobertura de envios:  ${userBalance.maxCoverage} Km`}<br></br>
                         </>):(<>
                         {
                        loadingBalance?(<>Sin registros</>):(<>
                          {
                            errorBalance?(<>No existe balance</>):(<>
                            Error279
                            </>)
                          }
                          
                          </>)
                         }
                          </>)          
                        }
                      </Box>
                      
                    </CardContent>
                    <Divider />
                  
                  
                  
        </Card> 
    </CardContent>
    <Divider />
    <CardActions>
      {/* <Button
        color="primary"
        fullWidth
        variant="text"
        
      >
        Actualizar foto
      </Button> */}
    </CardActions>
    </Card> 
    </Container>
    <AccountProfileDetails  props={props} userdata={userData}/>
    </Grid.Column>
    <Grid.Column  computer={4} mobile={16} tablet={16} className="dash-container-colmun" >
    <OpcionesLaterales serviciosAct={availableservices}/>
    </Grid.Column>
    </Grid.Row>
    
  </Grid>

    ); 

  };

export default Micuenta;
